import React, { useState } from 'react';


function CookiesPolicyBody(props) {

    const [side, setSide] = useState([
        {id:1,title:'Introduction'},
        {id:2,title:'What are Cookies'},
        {id:3,title:'How we use Cookies'},
        {id:4,title:'Third-party Cookies'},
        {id:5,title:'Cookie Management'},
        {id:6,title:'Your Consent'},
        {id:7,title:'Data Privacy and Security'},
        {id:8,title:'Updates to this Cookies Policy'},
        {id:9,title:'Applicable Law'},
        {id:10,title:'Contact Us'},
    ])

    const [active, setActive] = useState(1)

    const changeActive = (id) => {
        setActive(id)
        document.getElementById(id).scrollIntoView({behavior:'smooth'})
        
    }

    return (
        <div className='flex flex-col px-5 lg:px-10 mt-5 lg:mt-10 mb-10 lg:mb-20'>
            <div className='text-center text-[30px] lg:text-[48px] font-[500]'>Cookies Policy</div>
            <div className='grid grid-cols-8 gap-x-10 mt-5 lg:mt-10'>
            <div className='hidden h-[420px] lg:flex col-span-2 rounded-[8px] py-5 px-3 flex flex-col bg-[#FBFBFB] border-[1px] border-[#E0E0E0] space-y-3'>
                {side.map(({id,title}) => {
                    return (
                        <span onClick={() => changeActive(id)} key={id} className={`cursor-pointer text-start font-[400] text-[16px] ${active == id ? 'text-[#008B39]' : 'text-[#737373]'}`}>{title}</span>
                    )
                })}
            </div>
            <div className='col-span-8 lg:col-span-6 flex flex-col text-[#424242] text-[16px] text-start space-y-2'>
                <div className='flex flex-col'>
                    <span>Cookie Policy for Yebokenny App</span>
                    <span>Effective Date: 1st September, 2023</span>
                </div>
                <div id='1' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>1. Introduction</span>
                    <span>Welcome to Yebokenny App ("us", "we", or "our"). 
                        This Cookie Policy explains how we use cookies and similar 
                        technologies to improve your browsing experience and provide 
                        you with personalized services. By using our App, you 
                        consent to the use of cookies as described in this policy.
                    </span>
                </div>
                <div id='2' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>2. What Are Cookies ?</span>
                    <span>Cookies are small text files that are placed on your 
                        device (computer, tablet, or mobile) when you visit our App. 
                        They are widely used to make websites work efficiently and 
                        enhance your browsing experience. Cookies may store certain 
                        information about your preferences and activities on our App
                    </span>
                </div>
                <div id='3' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>3. How We Use Cookies</span>
                    <span className='flex flex-col'>
                        <span>We use cookies for various purposes, including but not limited to</span>
                        <span>A. Essential Cookies: These cookies are necessary for the functioning of our App and enable core features such as security, authentication, and accessibility. They cannot be disabled through our systems</span>
                        <span>B. Analytical Cookies: These cookies help us gather information about how users interact with our App. We use this data to analyse user behaviour, improve the performance of our App, and enhance user experience.</span>
                        <span>C. Functional Cookies: These cookies allow us to remember your preferences and choices (e.g., language preferences) to provide you with a more personalized experience.</span>
                        <span>D. Advertising Cookies: We may use these cookies to deliver relevant advertisements to you based on your interests and browsing behaviour. They also help us measure the effectiveness of our advertising campaigns</span>
                    </span>
                </div>
                <div id='4' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>4. Third-Party Cookies</span>
                    <span>We may allow third-party service providers, such as analytics 
                        and advertising partners, to place cookies on your device when 
                        you use our App. These third-party cookies are subject to 
                        the respective privacy policies of those providers
                    </span>
                </div>
                <div id='5' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>5. Cookie Management</span>
                    <span>You have the right to control whether or not to accept cookies. 
                        Most web browsers automatically accept cookies, but you can modify 
                        your browser settings to decline cookies or notify you when a 
                        cookie is being placed on your device. Please note that blocking 
                        or deleting cookies may impact the functionality of our App 
                        and limit your access to certain features.
                    </span>
                </div>
                <div id='6' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>6. Your Consent</span>
                    <span>By continuing to use our App, you consent to the use of cookies 
                        as described in this Cookie Policy. If you do not agree with 
                        this policy, please refrain from using our App or adjust 
                        your cookie settings accordingly.
                    </span>
                </div>
                <div id='7' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>7. Data Privacy And Security</span>
                    <span>We are committed to safeguarding your privacy and handling your 
                        personal data in accordance with applicable data protection 
                        laws and our Privacy Policy. We implement appropriate security 
                        measures to protect your information from unauthorized access 
                        or disclosure.  For more information about how we collect, use, 
                        and protect your personal data, please review our Privacy Policy.
                    </span>
                </div>
                <div id='8' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>8. Updates to this Cookie Policy</span>
                    <span>We may update this Cookie Policy from time to time to reflect 
                        changes in our practices or for other operational, legal, or 
                        regulatory reasons. We encourage you to review this policy 
                        periodically for any updates. The date at the top of this 
                        policy indicates the last revision date.
                    </span>
                </div>
                <div id='9' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>9. Applicable Law</span>
                    <span>This Cookie Policy shall be governed by and construed 
                        in accordance with the laws of South Africa.
                    </span>
                </div>
                <div id='10' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>Contact Us</span>
                    <span className='flex flex-col'>
                        <span>If you have any questions or concerns about this Cookie Policy, please contact us at:</span>
                        <span>Yebo Kenny Media Pty Ltd</span>
                        <span>Business@yebokenny.com</span>
                    </span>
                </div>
            </div>
        </div>
        </div>

    );
}

export default CookiesPolicyBody;